import axios from 'axios';
import queryString from 'query-string';
import moment from 'moment';
import store from '../../../redux/store';
import { userDetailSelector } from '../../../redux/selectors/user';
import { selectedOrganizationSelector } from '../../../redux/selectors/organization';

const getUserId = () => {
  return userDetailSelector(store.getState()).id;
};

const getOrganizationId = () => {
  return selectedOrganizationSelector(store.getState()).id;
};

const http = axios.create({
  baseURL: process.env.REACT_APP_AUTOMATED_CAMPAIGNS_WATCHER_BASE_URL,
  paramsSerializer: params =>
    queryString.stringify(params, { arrayFormat: 'comma' }),
});

http.interceptors.request.use(request => {
  request.headers.userid = getUserId();
  request.headers.organizationid = getOrganizationId();
  return request;
});

// Helper function to remove template.html and template.design from stages to reduce request size
const removeTemplateHtmlAndDesign = stages => {
  return stages.map(({ template, ...stage }) => {
    if (template) {
      const { html, design, ...restTemplate } = template;
      return { ...stage, template: restTemplate };
    }
    return stage;
  });
};

export const fetchProjectedDeliveriesFromACWatcher = async (
  audience,
  stages,
  year,
  month
) => {
  try {
    // Remove template.html and template.design from each stage to reduce request size otherwise it will be too large and will cause the request to fail
    const stagesWithoutTemplateHtmlAndDesign =
      removeTemplateHtmlAndDesign(stages);

    const { data } = await http.post('/api/projections', {
      audience,
      stages: stagesWithoutTemplateHtmlAndDesign,
      year,
      month,
    });
    return data?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const fetchProjectedDeliveriesByDate = async (
  audience,
  stages,
  date
) => {
  try {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    // Remove template.html and template.design from each stage to reduce request size otherwise it will be too large and will cause the request to fail
    const stagesWithoutTemplateHtmlAndDesign =
      removeTemplateHtmlAndDesign(stages);

    const { data } = await http.post(`/api/projections/${formattedDate}`, {
      audience,
      stages: stagesWithoutTemplateHtmlAndDesign,
    });
    return data?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};
